// Traductions du mode Lite : onboarding, écrans vides, checklist de démarrage.
export const fr = {
  flow: {
    skip: "Passer",
    step: (n: number, total: number) => `Étape ${n} sur ${total}`,
    welcomeTitle: "Bienvenue sur Edgely",
    welcomeLead: "Ton journal de trading. En 2 minutes, tu sauras ce qui te fait gagner et ce qui te fait perdre.",
    welcomePoints: [
      "Tes trades arrivent tout seuls depuis ton broker",
      "Tes stats te disent quoi corriger",
      "Tes comptes prop suivis : objectif, drawdown, payouts",
    ],
    continue: "Continuer",
    back: "Retour",
    profileTitle: "Comment trades-tu ?",
    profileLead: "On adapte ce que tu vois en premier.",
    profileProp: "Avec des prop firms",
    profilePropDesc: "Challenges et comptes funded : Apex, Topstep, TPT…",
    profilePersonal: "Sur mon propre compte",
    profilePersonalDesc: "Ton argent, chez ton broker",
    profileBoth: "Les deux",
    profileBothDesc: "Prop firms et compte personnel",
    tradesTitle: "Ajoute tes trades",
    tradesLead: "C'est la seule étape vraiment nécessaire. Tu pourras en ajouter d'autres plus tard.",
    broker: "Connecter Tradovate",
    brokerDesc: "Tes trades se synchronisent automatiquement, même ceux des prop firms.",
    brokerBadgeMax: "Recommandé",
    brokerBadgeOther: "Plan Max",
    csv: "Importer un fichier",
    csvDesc: "Un export CSV de ta plateforme",
    manual: "Saisir à la main",
    manualDesc: "Crée ton compte, puis ajoute ton premier trade",
  },
  empty: {
    connectBroker: "Connecter mon broker",
    importFile: "Importer un fichier",
    manualTrade: "Saisir un trade",
  },
  checklist: {
    title: "Bien démarrer",
    progress: (done: number, total: number) => `${done} sur ${total} étapes faites`,
    hide: "Masquer",
    account: "Ajouter un compte",
    accountDesc: "Prop firm ou compte perso, avec ses règles.",
    accountCta: "Ajouter",
    trades: "Ajouter tes trades",
    tradesDesc: "Connexion broker, import CSV ou saisie.",
    tradesCta: "Commencer",
    note: "Annoter un trade",
    noteDesc: "Une note ou un tag : la base pour progresser.",
    noteCta: "Ouvrir le journal",
  },
};

export const en: typeof fr = {
  flow: {
    skip: "Skip",
    step: (n: number, total: number) => `Step ${n} of ${total}`,
    welcomeTitle: "Welcome to Edgely",
    welcomeLead: "Your trading journal. In 2 minutes, you'll know what makes you win and what makes you lose.",
    welcomePoints: [
      "Your trades flow in automatically from your broker",
      "Your stats tell you what to fix",
      "Your prop accounts tracked: target, drawdown, payouts",
    ],
    continue: "Continue",
    back: "Back",
    profileTitle: "How do you trade?",
    profileLead: "We adapt what you see first.",
    profileProp: "With prop firms",
    profilePropDesc: "Challenges and funded accounts: Apex, Topstep, TPT…",
    profilePersonal: "On my own account",
    profilePersonalDesc: "Your money, at your broker",
    profileBoth: "Both",
    profileBothDesc: "Prop firms and a personal account",
    tradesTitle: "Add your trades",
    tradesLead: "This is the only step that really matters. You can add more later.",
    broker: "Connect Tradovate",
    brokerDesc: "Your trades sync automatically, including prop firm accounts.",
    brokerBadgeMax: "Recommended",
    brokerBadgeOther: "Max plan",
    csv: "Import a file",
    csvDesc: "A CSV export from your platform",
    manual: "Enter manually",
    manualDesc: "Create your account, then add your first trade",
  },
  empty: {
    connectBroker: "Connect my broker",
    importFile: "Import a file",
    manualTrade: "Enter a trade",
  },
  checklist: {
    title: "Get started",
    progress: (done: number, total: number) => `${done} of ${total} steps done`,
    hide: "Hide",
    account: "Add an account",
    accountDesc: "Prop firm or personal account, with its rules.",
    accountCta: "Add",
    trades: "Add your trades",
    tradesDesc: "Broker connection, CSV import or manual entry.",
    tradesCta: "Start",
    note: "Annotate a trade",
    noteDesc: "A note or a tag: the basis for improving.",
    noteCta: "Open the journal",
  },
};
